import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    ns: ['common', 'active-substance', 'active-substance-details', 'product', 'product-details', 'treatment-search', 'treatment-details', 'pfi-search', 'riskCalculator', 'general-search', 'serie', 'seo', 'breadcrumb'],
    defaultNS: 'translations',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    keySeparator: '.',
    nsSeparator: '|',
    backend: {
      backends: [HttpBackend, HttpBackend],
      backendOptions: [
        {
          // Primary: API (database translations)
          loadPath: '/api/translations/{{lng}}/{{ns}}/',
        },
        {
          // Fallback: Static JSON files
          loadPath:
            process.env.NODE_ENV === 'development'
              ? 'http://localhost:9091/locales/client/{{lng}}/{{ns}}.json'
              : '/static/locales/client/{{lng}}/{{ns}}.json',
        },
      ],
    },
    saveMissing: false,
  });

export default i18n;
